import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IArticlePropertyKey } from 'gen/ApiClient';
import React from 'react';

export const ArticlePropertyKeysCacheContext = React.createContext<IPreloadCacheContext<IArticlePropertyKey[]>>(undefined as any);
